import { snackbarWarning } from '../SharedFunctions';

export const handleAdminWarning = (message: string) => {
    snackbarWarning(message);
};
